export enum ReportEntryType {
  ERROR = "danger",
  INFO = "info",
  WARNING = "warning",
}
